import axios from '@/plugins/axios';
import { API_HOME } from '@/constants/api';
import type { Module } from 'vuex';
import { JuyoFlg } from '@/constants/constants';
import moment from 'moment';

export type Infomation = {
  title: string;
  subtitle: string;
  text: string;
  isExpand: boolean;
  isImportant: boolean;
};

export type G120 = {
  page: number;
  infomations: Infomation[];
};

const g120: Module<G120, unknown> = {
  namespaced: true,
  state() {
    return {
      page: 1,
      infomations: [],
      isExpand: false,
      isImportant: false,
    };
  },
  mutations: {
    INCREMENT_PAGE(state) {
      state.page++;
    },
    ADD_INFOMATIONS(state, payload: []) {
      state.infomations.push(...payload);
    },
    RESET_INFOMATIONS(state) {
      state.page = 1;
      state.infomations = [];
    },
  },
  getters: {
    infomations: (state) => state.infomations,
  },
  actions: {
    async get({ commit, state }, params) {
      const res = await axios.get(API_HOME, {
        params: {
          genzaiYmd: params.genzaiYmd,
          kainaiKaigaiKbn: params.kainaiKaigaiKbn,
          page: state.page,
        },
      });
      if (!res) {
        return;
      }
      const { responseData } = res.data;
      if (responseData) {
        const infomations = responseData.map(
          (info: {
            midashi: string;
            torokuDate: string;
            torokuSha: string;
            information: string;
            juyoFlg: number;
          }) => {
            let isImportant = false;
            const date = moment(info.torokuDate).format('YYYY-MM-DD');
            if (info.juyoFlg === JuyoFlg.JUYO) {
              isImportant = true;
            }
            return {
              title: info.midashi,
              subtitle: `${date}：${info.torokuSha}`,
              text: info.information,
              isExpand: false,
              isImportant: isImportant,
            };
          }
        );
        commit('INCREMENT_PAGE');
        commit('ADD_INFOMATIONS', infomations);
        params.loadState.loaded();
      } else {
        params.loadState.complete();
      }
    },
    reset({ commit }) {
      commit('RESET_INFOMATIONS');
    },
  },
};

export default g120;
